import React from "react";
import { Modal, Button } from "react-bootstrap";
import { getQueryString } from "pages/search/api/filterUrlMaker";
import { _t } from "app/i18n/i18n";

export const LeaveSiteWarning = () => {
  const { url, target = "_blank" } = getQueryString();

  return (
    <Modal show={true} onHide={() => window.history.back()}>
      <Modal.Header closeButton>
        <Modal.Title>{_t("Leaving the Global Research Portal")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{_t("You are now leaving the Global Research Portal.")}</p>
        <p>
          {_t(
            "Nomura podcasts and videos are presented for informational purposes only and are not Investment Research.",
          )}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => window.history.back()}>
          {_t("Back")}
        </Button>
        <a href={url} target={target} onClick={() => window.history.back()}>
          <Button variant="primary">{_t("Continue")}</Button>
        </a>
      </Modal.Footer>
    </Modal>
  );
};
